
import eventBus from "../event-bus";
import Vue, { CreateElement, VNode } from "vue";
import WScrollViewThumb from "./private/ScrollViewThumb.vue";

export default Vue.extend({
	data() {
		return {
			thumbs: [] as VNode[],
			eventBus,
			verticalScrollLoop: 0,
			autoScrollSpeed: 5,
			currentScrollTop: 0,
			currentScrollLeft: 0,
			mouseIn: 0,
			mouseDownWhileIn: false
		};
	},
	props: {
		tag: {
			type: String,
			default: "div"
		},
		x: {
			type: Boolean
		},
		y: {
			type: Boolean,
			default: true
		},
		tagAttributes: {
			type: Object as () => any,
			default: () => {}
		},
		ySnap: {
			type: Boolean
		},
		xSnap: {
			type: Boolean
		},
		parentScrollRef: {
			type: HTMLElement,
			required: false
		},
	},
	computed: {
		classes():any {
			let classes = { "w-scroll-view": true} as any;
			if (this.x) {
				classes.x = true;
			}
			if (this.y) {
				classes.y = true;
			}
			if (this.ySnap) {
				classes.ysnap = true;
			}
			if (this.xSnap) {
				classes.xSnap = true;
			}
			if (this.xSnap && this.ySnap) {
				classes.snap = true;
			}
			return classes;
		}
	},
	watch: {
		"eventBus.mouse.dragging": {
			handler(){
				if (!this.eventBus.mouse.dragging) {
					this.stopVerticalScroll();
				}
			}
		}
	},
	methods: {
		scrollTo(element:HTMLElement) {
			this.$el.scrollTop = element.offsetTop;
		},
		onMouseMove(event:MouseEvent){
			if (!eventBus.mouse.dragging) return;
			let offset = 50;
			let clientRect = this.$el.getBoundingClientRect();
			let isInX = event.pageX > clientRect.left && event.pageX < clientRect.right;
			let isInY = event.pageY > clientRect.top && event.pageY < clientRect.bottom;
			if (!isInX || !isInY) return;
			if (this.y) {
				if (event.pageY < (clientRect.top + offset) && event.pageY > clientRect.top) {
					this.startAutoScrollUp();
				}else if (event.pageY > (clientRect.bottom - offset) && event.pageY < clientRect.bottom) {
					this.startAutoScrollDown();
				}else {
					this.stopVerticalScroll();
				}
			}
		},
		startVerticalAutoScrollFunction(fn:()=>void){
			if (this.verticalScrollLoop != 0) return;
			let loop = 0;
			let handler = ()=>{
				if (this.verticalScrollLoop != loop){
					return;
				}
				fn();
				requestAnimationFrame(handler);
			};
			loop = setTimeout(handler, 500);
			this.verticalScrollLoop = loop;
		},
		startAutoScrollDown(){
			this.startVerticalAutoScrollFunction(()=>{
				this.$el.scroll({top: this.$el.scrollTop + this.autoScrollSpeed});
			});
		},
		startAutoScrollUp(){
			this.startVerticalAutoScrollFunction(()=>{
				this.$el.scroll({top: this.$el.scrollTop - this.autoScrollSpeed});
			});
		},
		stopVerticalScroll(){
			this.verticalScrollLoop = 0;
		},
		onScroll(){
			let diffY = this.$el.scrollTop - this.currentScrollTop;
			let diffX = this.$el.scrollLeft - this.currentScrollLeft;
			eventBus.$emit("scroll", this, {diffX, diffY});
			this.currentScrollTop = this.$el.scrollTop;
			this.currentScrollLeft = this.$el.scrollLeft;
		},
		onWindowMouseDown(){
			if (this.mouseIn > 0){
				this.mouseDownWhileIn = true;
			}
		},
		onWindowMouseUp(){
			this.mouseDownWhileIn = false;
		},
	},
	mounted() {
		this.$el.addEventListener("scroll", this.onScroll);
		this.$el.addEventListener("mouseenter", ()=>this.mouseIn++);
		this.$el.addEventListener("mouseleave", ()=>this.mouseIn--);
		window.addEventListener("mousemove", this.onMouseMove);
		window.addEventListener("mousedown", this.onWindowMouseDown);
		window.addEventListener("mouseup", this.onWindowMouseUp);
		this.currentScrollTop = this.$el.scrollTop;
		this.currentScrollLeft = this.$el.scrollLeft;
	},
	destroyed() {
		window.removeEventListener("mousemove", this.onMouseMove);
		window.removeEventListener("mousedown", this.onWindowMouseDown);
		window.removeEventListener("mouseup", this.onWindowMouseUp);
	},
	components: {
		WScrollViewThumb
	},
	render(createElement:CreateElement):VNode {
		if (this.thumbs.length == 0) {
			if (this.x) {
				let thumb = createElement("w-scroll-view-thumb", {attrs: {
					isHorizontal: true,
					parentScrollRef: this.parentScrollRef
				}});
				this.thumbs.push(thumb);
			}
			if (this.y) {
				let thumb = createElement("w-scroll-view-thumb", {attrs: {
					isHorizontal: false,
					parentScrollRef: this.parentScrollRef
				}});
				this.thumbs.push(thumb);
			}
		}
		let toUseThumbs = [...this.thumbs];
		if (this.mouseIn <= 0 && !this.mouseDownWhileIn){
			toUseThumbs = [];
		}
		return createElement(this.tag, {
				class: this.classes,
				attrs: {
					...this.$attrs,
					...this.tagAttributes
				},
			},
			[
				...toUseThumbs,
				...(this.$slots.default || [])
			]);
	}
});
